import { render, staticRenderFns } from "./CultureAssetRegisterAudit.vue?vue&type=template&id=530b6170&scoped=true&"
import script from "./CultureAssetRegisterAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAssetRegisterAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b6170",
  null
  
)

export default component.exports